module.exports = __webpack_public_path__ + "../resources/images/illustration_inbox-25c3fb01cf67fac3f00a39218d1e1f4b.svg";